<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/classesTime')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="time_start">Time Start</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr id="time_start" :config="config" v-model="editData.time_start" name="time_start" v-validate="'required'" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('time_start') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="time_end">Time End</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr id="time_end" :config="config" v-model="editData.time_end" name="time_end" v-validate="'required'" class="w-100"></flat-pickr>
                  <span class="error">{{ errors.first('time_end') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Studio</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="studio" v-validate="'required'" v-model="editData.studio_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in optStudio" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                  <span class="error">{{ errors.first('studio') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-30">
                <b-col sm="2">
                  <label for="status">Status</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="status" v-validate="'required'" v-model="editData.status" :options="options" />
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'editClassesTime',
  data: function () {
    return {
      editData: {
        time_start: '',
        time_end: '',
        status: null,
        studio_id: null
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      optStudio: [
      ],
      config: {
        enableTime: true,
        noCalendar: true,
        defaultDate: "00:00",
        time_24hr: true
      }
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          // console.log(this.description)
          axios.put('fitness/v1/classes_time/'+(this.$route.query.id), this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/classesTime')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/classes_time/single/'+(this.$route.query.id)).then(response => {
        // console.log('test', response)
        this.editData.time_start = response.data.data.time_start
        this.editData.time_end = response.data.data.time_end
        this.editData.studio_id = response.data.data.studio_id
        this.editData.status = response.data.data.status
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc').then(response => {
        this.optStudio = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
